import React from "react"
import styled from "styled-components"
import { appStrings } from "../../common/strings/app_strings"
import { SimpleSelect } from "react-selectize"

const { selectPendingTeam, selectTeamDetail } = appStrings.connectedApps

export function SelectTeamDropdownForm() {
    return {
        render() {
            const { selectTeam, availableTeams } = this.props
            const options = availableTeams.map(team => {
                const { id, name, isPersonal } = team
                const label = isPersonal ? `${name} (you)` : name
                return { label, value: name, id }
            })
            return (
                <SimpleSelectWrapper className="settings-forms-container">
                    <div className="field-detail">{selectTeamDetail}</div>
                    <SimpleSelect
                        id="simple-select-style"
                        options={options}
                        onValueChange={team => {
                            return team ? selectTeam(team.id) : selectTeam(null)
                        }}
                        theme="bootstrap3"
                        placeholder={selectPendingTeam}
                    ></SimpleSelect>
                </SimpleSelectWrapper>
            )
        },
    }
}

const SimpleSelectWrapper = styled.div`
    width: 64%;
    h4 {
        font-weight: 600;
        margin: 0;
        font-size: 16px;
        display: inline-flex;
        padding-bottom: 21px;
    }
    .field-detail {
        font-weight: 400;
        font-size: small;
        margin: 0;
        padding-bottom: 8px;
    }
    #simple-select-style {
        width: 500px !important;
    }
    .react-selectize.bootstrap3.root-node .react-selectize-control {
        border-color: #ccc !important;
        outline: none !important;
        box-shadow: none !important;
    }

    @media (max-width: 1000px) {
        width: 100% !important;
        #simple-select-style {
            width: 100% !important;
        }
    }
`



// WEBPACK FOOTER //
// ./src/common/components/select_team_dropdown.js